export default __webpack_public_path__ + "static/media/Proof_of_address.6cf8567c.svg";